export class IntervalInfo {
    notifyUpdatesIntervalMinute: number;
    nextNotify: number;
 }
